import { useEffect, useRef, useState } from 'react';

export const useCounter = ({ expired, countFrom }) => {
  const [count, setCount] = useState(countFrom);
  const intervalRef = useRef();
  const expiredRef = useRef();
  expiredRef.current = expired;

  useEffect(() => {
    function clearIntervalRef() {
      if (!intervalRef.current) {
        return;
      }

      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    function handleExpire() {
      clearIntervalRef();
      expiredRef.current();
    }

    function start() {
      if (intervalRef.current) {
        clearIntervalRef();
      }

      let count = countFrom;

      intervalRef.current = setInterval(() => {
        count--;

        if (count <= 0) {
          handleExpire();
        } else {
          setCount(count);
        }
      }, 1000);
    }

    start();

    return clearIntervalRef;
  }, [countFrom]);

  return { count };
};
